import React, { useEffect } from 'react';

import { OrdersListPage } from '@components/OrdersListPage';
import { ScreenContent } from '@components/ScreenContent';
import { useAcceptedOrdersStore } from '@stores';
import { useTranslation } from '@providers/I18n';

export const AcceptedOrdersScreen: React.FC = () => {
  const { t } = useTranslation();
  const {
    orders: acceptedOrders,
    loading,
    fetch: fetchDriversInfo,
  } = useAcceptedOrdersStore();

  useEffect(() => {
    const interval = setInterval(() => {
      fetchDriversInfo();
    }, 60000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ScreenContent>
      <OrdersListPage
        ordersList={acceptedOrders}
        loading={loading}
        type="Accepted"
        title={t('acceptedOrders.header', 'Accepted orders')}
        noOrdersMessage={t('acceptedOrders.noAcceptedOrdersAtTheMoment', {
          defaultValue: 'No accepted orders at the moment',
        })}
        loadedAllOrdersMessage={t('acceptedOrders.loadedAllOrdersMessage', {
          defaultValue: 'Loaded all ({{ordersCount}}) accepted orders',
          ordersCount: acceptedOrders.length,
        })}
      />
    </ScreenContent>
  );
};
